module.exports = __webpack_public_path__ + "static/media/screen1.a0573791.jpg";